<div class="gallery-container">
  <div class="gallery-header">
    <h2>My Gallery</h2>
    <p>All your saved memories in one place</p>
  </div>

  @if (isLoading) {
    <div class="loading-state">
      <div class="spinner"></div>
      <p>Loading your gallery...</p>
    </div>
  } @else if (galleryItems.length === 0) {
    <div class="empty-state">
      <div class="empty-icon">🖼️</div>
      <h3>No photos yet</h3>
      <p>When you scan a QR code from the photobooth and claim your photos, they will appear here.</p>
    </div>
  } @else {
    <div class="album-book-wrapper">
      <div class="gallery-grid">
        @for (item of paginatedItems; track item.id) {
          <div class="gallery-item" (click)="openModal(item.url)">
            <div class="media-box" [class.is-landscape]="photoOrientations[item.id] === '6x4'" [class.is-portrait]="photoOrientations[item.id] === '4x6'">
              <span class="badge">{{ item.type === 'gif' ? 'GIF' : 'Photo' }}</span>
              <img [src]="item.url" [alt]="item.type === 'gif' ? 'Saved GIF' : 'Saved Photo'" loading="lazy" (load)="onImageLoad($event, item.id, item.cutStyle)" />
              @if (photoOrientations[item.id] === '4x6') {
                <img class="photo-overlay" src="Assets/my-gallery/photooverlay_4x6.png" alt="Overlay" />
              } @else if (photoOrientations[item.id] === '6x4') {
                <img class="photo-overlay" src="Assets/my-gallery/photooverlay_6x4.png" alt="Overlay" />
              }
            </div>
            <div class="item-footer">
              <span class="date">{{ item.savedAt?.toDate() | date:'MM.dd.yy' }}</span>
            </div>
          </div>
        }
      </div>

      <!-- Pagination Bar at the bottom -->
      <div class="pagination-bar">
        <button class="nav-page-btn prev-btn" (click)="prevPage()" [disabled]="currentPage === 1">
          ‹ Previous
        </button>
        <span class="page-indicator">{{ currentPage }} / {{ totalPages }}</span>
        <button class="nav-page-btn next-btn" (click)="nextPage()" [disabled]="currentPage === totalPages">
          Next ›
        </button>
      </div>
    </div>
  }

  @if (selectedMedia) {
    <div class="modal-overlay" (click)="closeModal()">
      <!-- Top header bar for the modal -->
      <div class="modal-header-bar" (click)="$event.stopPropagation()">
        <button class="modal-close-btn" (click)="closeModal()" aria-label="Close">✕</button>
        <img class="modal-logo" src="Assets/KPhoto-Logo 4.png" alt="KPhoto Logo" />
      </div>
      
      <div class="modal-content" (click)="$event.stopPropagation()">
        <img class="modal-photo" [src]="selectedMedia" alt="Enlarged media" />
      </div>
    </div>
  }
</div>

